<app-page-container>
  <app-header appTitle="Bem vindo ao Portal {{environment.companyName}}" divider>
    <p class="sub-titulo">Aqui você pode solicitar suprimentos, abrir chamados para assistência técnica e muito
      mais.</p>
  </app-header>
  <div class="texto-e-imagem">
    <div class="lista-opcoes">
      <div *ngIf="this.autorizacoes.abrirChamadoEquipamento">
        Para visualizar suas faturas, <a class="clique-aqui-link" routerLink="/demonstrativo-financeiro">clique
          aqui</a>.
      </div>

      <div *ngIf="this.autorizacoes.abrirChamadoEquipamento">
        Para visualizar seus boletos, <a class="clique-aqui-link" routerLink="/boletos">clique aqui</a>.
      </div>

      <div *ngIf="this.autorizacoes.listarEquipamentos">
        Para visualizar seus equipamentos, <a class="clique-aqui-link" routerLink="/equipamentos">clique aqui</a>.
      </div>

      <div *ngIf="this.autorizacoes.abrirChamadoEquipamento">
        Para solicitar assistência técnica, <a class="clique-aqui-link" routerLink="/equipamento/abrir-chamado/1">clique
          aqui</a>.
      </div>

      <div *ngIf="this.autorizacoes.listarChamadosAndamento || this.autorizacoes.listarChamadosFinalizados">
        Para visualizar seus chamados de assistência técnica,
        <a class="clique-aqui-link"
          [routerLink]="autorizacoes.listarChamadosAndamento ? '/historico-chamados' : '/historico-chamados/finalizados'">clique
          aqui</a>.
      </div>

      <div *ngIf="this.autorizacoes.abrirChamadoSuprimentos">
        Para solicitar suprimentos para seus equipamentos, <a class="clique-aqui-link"
          routerLink="/novo-suprimento/abrir-chamado/{{environment.company}}/1">clique aqui</a>.
      </div>


      <div *ngIf="this.autorizacoes.listarHistoricosPedidos">
        Para visualizar suas solicitações de suprimentos, <a class="clique-aqui-link"
          routerLink="/suprimentos/historico-de-pedidos">clique aqui</a>.
      </div>

      <div *ngIf="this.autorizacoes.listarUsuarios || this.autorizacoes.listarPerfis">
        Para gerenciar seus usuários, <a class="clique-aqui-link"
          [routerLink]="autorizacoes.listarUsuarios ? '/gestao-de-acesso' : '/gestao-de-acesso/perfil'">clique
          aqui</a>.
      </div>
    </div>
    <div class="c-container-animacao">
      <ng-lottie width="30rem" [options]="options"></ng-lottie>
    </div>
  </div>
</app-page-container>
